import Vue from 'vue'
import VueAxios from 'vue-axios'
import axios from 'axios'
import store from '@/store'
import Configuration from '@/utils/configuration'
import router from '@/router'

axios.defaults.baseURL = Configuration.value('backendHost') + '/api/';

axios.interceptors.request.use((config) => {
    if (store.getters.currentUser) {
        // Set JWT before request is sent
        config.headers.common['Authorization'] = 'Bearer ' + store.getters.token
    }
    return config
}, (error) => {
    // Do something with request error
    return Promise.reject(error)
});

let isAlreadyFetchingAccessToken = false
let subscribers = []

function onAccessTokenFetched(access_token) {
    subscribers = subscribers.filter(callback => callback(access_token))
}

function addSubscriber(callback) {
    subscribers.push(callback)
}

axios.interceptors.response.use(function (response) {
    return response
}, function (error) {
    const { config, response: { status } } = error
    const originalRequest = config

    if (status === 401) {
        if (!isAlreadyFetchingAccessToken) {
            isAlreadyFetchingAccessToken = true

            // instead of this store call you would put your code to get new token  
            store.dispatch("refresh").then(() => {
                onAccessTokenFetched(store.getters.token)
                isAlreadyFetchingAccessToken = false;
            }).catch(error=>{
                router.push('authentication/signin')
            })
        }

        const retryOriginalRequest = new Promise((resolve) => {
            addSubscriber(access_token => {
                originalRequest.headers.Authorization = 'Bearer ' + access_token
                resolve(axios(originalRequest))
            })
        })
        return retryOriginalRequest
    }
    return Promise.reject(error)
})

Vue.use(VueAxios, axios);
